'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loginPath = exports.getActionPath = exports.resolveActionPath = undefined;

var _constant = require('../constant');

var _constant2 = _interopRequireDefault(_constant);

var _platform = require('./platform');

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isMZFilmWeb = (0, _platform2.default)().app.isMZFilmWeb();
var isMZFilm = (0, _platform2.default)().app.isMZFilm();

// 解析 actionType 跳转路径
var resolveActionPath = exports.resolveActionPath = function resolveActionPath(_ref) {
  var actionType = _ref.actionType,
      actionData = _ref.actionData;

  // actionData = actionData //&& JSON.parse(actionData)
  switch (actionType) {
    case 1:
      return { path: '/' };
    case 2:
      return { path: '/', query: { redirect: actionData.url } };
    case 3:
      return { path: '/' };
    case 4:
      return { path: '/search/result', query: { keyword: actionData.txt, type: 0 } };
    case 5:
      var rechargeType = ['fuel', 'cost', 'flow'];
      return { path: '/recharge/' + rechargeType[actionData.businessId] };
    case 6:
      return { path: '/category/' + actionData.businessId };
    case 7:
      var actionId = actionData.businessId || actionData.childId;
      if (actionData.param == '1') {
        return { path: '/product/' + actionId };
      } else {
        return { path: '/group/' + actionId };
      }
    case 8:
      return { path: '/topic/' + actionData.businessId };
    case 9:
      return { path: '/center' };
    case 10:
      return { path: '/user' };
    case 11:
      return { path: '/user/address' };
    case 12:
      if (isMZFilmWeb) {
        return { path: '/', query: { redirect: _constant2.default.MAIZUO_MOVIE_HOST + '#/user/card' } };
      } else {
        return { path: '/user/card' };
      }
    case 13:
      return { path: '/cart' };
    case 14:
      return { path: '/user/order' };
    case 15:
      return { path: '/user/order/' + actionData.businessId };
    case 16:
      var urlRE = /^(((https?|ftp|news):\/\/|\w+(\.\w+)+)(:\w+)?).*/;
      if (urlRE.test(actionData.businessId)) {
        return { path: '/', query: { redirect: actionData.businessId } };
      }
      return { path: '/card/query/' + actionData.businessId };
    case 17:
      if (isMZFilmWeb) {
        return { path: '/', query: { redirect: _constant2.default.MAIZUO_MOVIE_HOST } };
      } else {
        return { path: '/', query: { redirect: _constant2.default.SDYXMALL_MOVIE_HOST } };
      }
    case 18:
      return { path: '/enterprise' };
    case 19:
      return { path: '/category/' + actionData.businessId, query: { type: _constant2.default.SEARCH_TYPE_IS_ENTERPRISE } };
    case 20:
      return { path: '/enterprise' };
    case 21:
      return { path: '/search/result2', query: actionData };
    case 22:
      if (isMZFilmWeb) {
        return { path: '/', query: { redirect: _constant2.default.MAIZUO_MOVIE_HOST + '#/film/' + actionData.businessId } };
      } else {
        return { path: '/', query: { redirect: _constant2.default.SDYXMALL_MOVIE_HOST + '#/film/' + actionData.businessId } };
      }
    case 23:
      if (isMZFilmWeb) {
        return { path: '/', query: { redirect: _constant2.default.MAIZUO_MOVIE_HOST + '#/cinema/' + actionData.businessId + '/film' } };
      } else {
        return { path: '/', query: { redirect: _constant2.default.SDYXMALL_MOVIE_HOST + '#/cinema/' + actionData.businessId + '/film' } };
      }
    case 24:
      if (isMZFilmWeb) {
        return { path: '/', query: { redirect: _constant2.default.MAIZUO_ACT_HOST + 'group/' + actionData.businessId + '/' } };
      } else {
        return { path: '/', query: { redirect: _constant2.default.SDYXMALL_ACT_HOST + 'group/' + actionData.businessId + '/' } };
      }
    case 25:
      if (isMZFilmWeb) {
        return { path: '/', query: { redirect: _constant2.default.MAIZUO_ACT_HOST + 'group/' } };
      } else {
        return { path: '/', query: { redirect: _constant2.default.SDYXMALL_ACT_HOST + 'group/' } };
      }
    case 28:
      return { path: '/recommend' };
    case 29:
      return { path: '/global/' + actionData.businessId };
    case 57:
      return { path: '/user/order/self-service/' + actionData.businessId };
    case 40:
      return { path: '/zone/' + actionData.businessId };
    case 41:
      return { path: '/zone/filter/' + actionData.businessId };
    case 102:
      return { path: '/', query: { redirect: loginPath() } };
    case 103:
      return { path: '/preorder/' + actionData.businessId };
    default:
      return '';
  }
};

//将resolveActionPath返回的路由对象解析成url字符串
var getActionPath = exports.getActionPath = function getActionPath(actionOption) {
  var _resolveActionPath = resolveActionPath(actionOption),
      path = _resolveActionPath.path,
      _resolveActionPath$qu = _resolveActionPath.query,
      query = _resolveActionPath$qu === undefined ? {} : _resolveActionPath$qu;

  var queryStr = '';
  // 需要跳外部链接的地址
  if (query.redirect) {
    return query.redirect;
  }
  for (var param in query) {
    queryStr += param + '=' + query[param] + '&';
  }
  if (isMZFilmWeb) {
    return _constant2.default.MAIZUO_H5_HOST + '#' + path + '?' + queryStr.slice(0, -1);
  } else {
    return _constant2.default.SDYXMALL_H5_HOST + '#' + path + '?' + queryStr.slice(0, -1);
  }
};

var loginPath = exports.loginPath = function loginPath(url) {
  var toUrl = url || window.location.href;
  if (isMZFilmWeb) {
    return _constant2.default.MAIZUO_AUTH_LOGIN_PAGE_URL + "?redirectUri=" + encodeURIComponent(toUrl);
  } else {
    return _constant2.default.SDYXMALL_AUTH_LOGIN_PAGE_URL + "?redirectUri=" + encodeURIComponent(toUrl);
  }
};